import { z } from 'zod';
import { PublishedStudyDetailSchema } from './entity';
import { toRequired } from '../utils/schema';
import { validateCrossQuestionnaires } from '../conditions';

export const COMPUTED_FIELDS = [
  'id',
  'status',
  'createdAt',
  'publishedAt',
  'publishedBy',
  'startDate',
  'endDate',
  'participantDurationInMinutes',
  'temporalStatus',
] as const;

export const PublishValidationBaseSchema = PublishedStudyDetailSchema.omit(
  toRequired(COMPUTED_FIELDS),
);

export const PublishValidationSchema = PublishValidationBaseSchema.superRefine(
  validateCrossQuestionnaires,
);

export type PublishValidation = z.infer<typeof PublishValidationBaseSchema>;

/**
 * Gets the required keys of a zod schema as a union of string literals.
 * This utility works for StudyPublishValidationSchema to extract required field names.
 */
type RequiredKeys<T extends z.ZodTypeAny> =
  T extends z.ZodObject<infer Shape, any, any, any>
    ? {
        [K in keyof Shape]: Shape[K] extends {
          _def: { typeName: infer TypeName };
        }
          ? TypeName extends string
            ? TypeName extends 'ZodOptional'
              ? never
              : K
            : never
          : never;
      }[keyof Shape]
    : never;

/**
 * Union type of all required field names in StudyPublishValidationSchema.
 */
export type StudyPublishRequiredField = RequiredKeys<
  typeof PublishValidationSchema
>;
